import { render, staticRenderFns } from "./MailboxUsers.vue?vue&type=template&id=24fcb2ec&scoped=true&"
import script from "./MailboxUsers.vue?vue&type=script&lang=js&"
export * from "./MailboxUsers.vue?vue&type=script&lang=js&"
import style0 from "./MailboxUsers.vue?vue&type=style&index=0&id=24fcb2ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fcb2ec",
  null
  
)

export default component.exports